import { render, staticRenderFns } from "./FormFixedAssetCategory.vue?vue&type=template&id=1f9801fd"
import script from "./FormFixedAssetCategory.vue?vue&type=script&lang=js"
export * from "./FormFixedAssetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports